import { createContext } from 'react';

export const Language = createContext(null);
